import React from 'react';
import styles from './style.module.css';
import StepEightForm from '../../components/forms/step-eight';

export default () => (
    <div className={styles.page}>
        <p className={styles.topTitle}>Money Out</p>
        <h2 className={styles.mainTitle}>What I spend</h2>
        <StepEightForm/>
    </div>
);
